// Nombres legibles de las páginas para el asistente IA.
// La clave es el nombre de la ruta (o su patrón, para las rutas sin nombre).
// Solo descripciones de la interfaz: nunca datos de clientes.

const PAGINE = {
  Dashboard: "Dashboard",
  "Dashboard-due": "Dashboard",
  "Dashboard-tre": "Dashboard",
  ProfiloUtente: "Profilo utente",
  search: "Ricerca generale",
  Faqs: "FAQ",
  organigramma: "Organigramma",

  // Bacheca
  circolari: "Circolari",
  CompleteStats: "Report statistiche",
  Statistiche: "Statistiche",
  "Statistiche-report-crm": "Statistiche report CRM",
  StatisticheProduzione: "Statistiche produzione",
  DettaglioStatistiche: "Dettaglio statistiche",
  ReportFiliali: "Report filiali",
  ReportAgenti: "Report agenti",
  ReportExecutive: "Report executive",
  ReportTopManager: "Report top manager",
  ReportProduzioneExecutive: "Report produzione executive",
  ClassificaAgenti: "Classifica agenti",
  ClassificaExecutive: "Classifica executive",
  ClassificaTopManager: "Classifica top manager",
  ClassificaFiliali: "Classifica filiali",
  RecruitmentDashboard: "Dashboard recruitment",
  RecruitmentVisite: "Visite recruitment",

  // Anagrafiche
  clienti: "Clienti",
  lead: "Lead",
  "lead-convertiti": "Lead convertiti",
  corporate: "Anagrafiche corporate",
  negozi: "Negozi",
  recruitment: "Anagrafiche recruitment",
  academy: "Anagrafiche academy",
  recruitmentImport: "Importazione recruitment",
  academyImport: "Importazione academy",

  // CRM
  crm: "Scheda cliente (CRM)",
  "corporate-crm": "Scheda cliente corporate (CRM)",
  "recruitment-crm": "Scheda recruitment (CRM)",
  AcademyCrmDetail: "Scheda academy (CRM)",

  // Agenda
  calendario: "Calendario",

  // Pratiche
  "dettaglio-pratica": "Dettaglio pratica",
  "dettaglio-pratica-corporate": "Dettaglio pratica corporate",
  "richieste-finanziamento": "Richieste di finanziamento",
  "pratica-hub": "Nuova pratica",
  "preventivatore-hub": "Preventivatore",
  preventivatore: "Preventivatore",
  preventivi: "Preventivi",
  "preventivo-mutuo": "Preventivo mutuo",
  "preventivo-prestito": "Preventivo prestito",
  "preventivo-cqs": "Preventivo CQS",
  "nuovo-mutuo": "Nuovo mutuo",
  "nuovo-prestito": "Nuovo prestito",
  "nuovo-prestito-finalizzato": "Nuovo prestito finalizzato",
  "nuovo-leasing": "Nuovo leasing",
  "nuova-cqs": "Nuova CQS",
  "nuova-delega": "Nuova delega",
  "nuova-corporate": "Nuova pratica corporate",
  bozze: "Pratiche in bozza",
  "in-lavorazione": "Pratiche in lavorazione",
  erogate: "Pratiche erogate",
  annullate: "Pratiche annullate",
  archiviate: "Pratiche archiviate",
  rinnovabili: "Pratiche rinnovabili",
  OAM: "Pratiche OAM",
  "statistiche-pratiche": "Statistiche pratiche",
  "corporate-bozze": "Pratiche corporate in bozza",
  "corporate-in-lavorazione": "Pratiche corporate in lavorazione",
  "corporate-deliberate": "Pratiche corporate deliberate",
  "corporate-erogate": "Pratiche corporate erogate",
  "corporate-nonaccolte": "Pratiche corporate non accolte",
  "corporate-perfezionate": "Pratiche corporate perfezionate",
  "corporate-ritirate": "Pratiche corporate ritirate",

  // Amministrazione (rutas sin nombre)
  "/amministrazione/provvigioni": "Provvigioni",
  "/amministrazione/spese": "Spese",
  "/amministrazione/incassi": "Incassi",
  "/amministrazione/scadenziario-pagamenti": "Scadenziario pagamenti",
  "/amministrazione/note-spesa": "Note spesa",
  "/amministrazione/ordini": "Ordini",
  "/amministrazione/fornitori": "Fornitori",

  // Supporto
  legale: "Supporto legale",
  it: "Supporto IT",
  "supporto-pratiche": "Supporto pratiche",
  "supporto-amministrazione": "Supporto amministrazione",

  // Plugin
  CalcolatoreEstinzione: "Calcolatore estinzione",
  DataDrive: "Data Drive",
};

// Sección según el primer segmento de la ruta
const SEZIONI = {
  bacheca: "Bacheca",
  anagrafiche: "Anagrafiche",
  agenda: "Agenda",
  pratiche: "Pratiche",
  amministrazione: "Amministrazione",
  gestione: "Gestione",
  supporto: "Supporto",
  plugins: "Plugin",
  importatore: "Importatore",
  crm: "CRM",
  "corporate-crm": "CRM",
  "recruitment-crm": "CRM",
  "academy-crm": "CRM",
};

/**
 * Patrón de la ruta actual, sin valores (p. ej. "/pratiche/dettaglio-pratica/:idPratica").
 * Sirve de identificador para las rutas sin nombre.
 */
export function patternRoute(route) {
  const ultima = route.matched[route.matched.length - 1];
  return ultima ? ultima.path : route.path;
}

/** Nombre legible y sección de la página actual. */
export function infoPagina(route) {
  const pattern = patternRoute(route);
  const titoloMeta =
    typeof route.meta?.title === "string"
      ? route.meta.title.replace(/^DataRete Cloud\s*-\s*/, "")
      : undefined;
  const primoSegmento = pattern.split("/").filter(Boolean)[0];

  return {
    pagina: PAGINE[route.name] || PAGINE[pattern] || titoloMeta,
    sezione: SEZIONI[primoSegmento],
  };
}
